var map = {
	"./affect/Stats.vue": [
		"a2df",
		"chunk-2d208129"
	],
	"./cognitive-function/Stats.vue": [
		"ce71",
		"chunk-2d2223b2"
	],
	"./energy-fatigue/Stats.vue": [
		"3c61",
		"chunk-2d0c4a41"
	],
	"./pain/Stats.vue": [
		"6b50",
		"chunk-2d0da37d"
	],
	"./sleep/Stats.vue": [
		"6304",
		"chunk-3a2aac1e"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "cf9e";
module.exports = webpackAsyncContext;